import React from "react";
import { Icon } from "../numberSenseUi";

/* ============================================================
   Number Sense — end-of-lesson screen (pass or fail).
   `info` is the outcome the page computed in finishLesson:
     pass → { passed:true, award, acc, hearts, hasGroove }
     fail → { passed:false, correct, total, reachedGroove }
   onGroove relaunches the lesson from its timed groove finale:
   a replay-for-fun after a pass, a pick-up-where-you-slipped
   after a fail that made it to the groove.
   ============================================================ */
const DoneScreen = ({ info, onHome, onRetry, onGroove }) => {
  if (info.passed) {
    return (
      <div className="ns-root">
        <div className="ns-app">
          <div className="done-screen">
            <div className="trophy">
              <Icon name="trophy" />
            </div>
            <div className="big">lesson down!</div>
            <div className="sub">numbers locking in — nicely done</div>
            <div className="scorecards">
              <div className="scorecard sc-xp">
                <div className="k">XP earned</div>
                <div className="v">+{info.award}</div>
              </div>
              <div className="scorecard sc-acc">
                <div className="k">accuracy</div>
                <div className="v">{info.acc}%</div>
              </div>
              <div className="scorecard">
                <div className="k">hearts</div>
                <div className="v" style={{ color: "var(--red)" }}>
                  {info.hearts}
                </div>
              </div>
              {info.timing && (
                <div className="scorecard">
                  <div className="k">on the beat</div>
                  <div className="v">{info.timing.onTimePct}%</div>
                  {info.timing.avgMs != null && (
                    <div className="k">~{info.timing.avgMs}ms late</div>
                  )}
                </div>
              )}
            </div>
            <button className="btn" style={{ maxWidth: 320 }} onClick={onHome}>
              Continue
            </button>
            {info.hasGroove && (
              <button
                className="btn ghost"
                style={{ maxWidth: 320, marginTop: 12 }}
                onClick={onGroove}
              >
                Run the groove again
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="ns-root">
      <div className="ns-app">
        <div className="done-screen">
          <div className="fail-mark" style={{ color: "var(--red)" }}>
            <Icon name="heartbreak" />
          </div>
          <div className="big">out of hearts</div>
          <div className="sub">
            mistakes are how the ear learns. give it another go.
          </div>
          <div className="scorecards">
            <div className="scorecard sc-acc">
              <div className="k">got right</div>
              <div className="v">
                {info.correct}/{info.total}
              </div>
            </div>
          </div>
          {info.reachedGroove ? (
            <>
              <button
                className="btn loje"
                style={{ maxWidth: 320, marginBottom: 12 }}
                onClick={onGroove}
              >
                Back to the groove
              </button>
              <button
                className="btn ghost"
                style={{ maxWidth: 320, marginBottom: 12 }}
                onClick={onRetry}
              >
                Restart the lesson
              </button>
            </>
          ) : (
            <button
              className="btn loje"
              style={{ maxWidth: 320, marginBottom: 12 }}
              onClick={onRetry}
            >
              Try again
            </button>
          )}
          <button className="btn ghost" style={{ maxWidth: 320 }} onClick={onHome}>
            Back to path
          </button>
        </div>
      </div>
    </div>
  );
};

export default DoneScreen;
